import React from 'react';
import classNames from 'classnames';
import Classes from './Classes';

const arrow = (icon, cssClasses) =>
  ({
    onClick, fireMixpanelEvent, text, className, tag, exhibitorId // eslint-disable-line react/prop-types
  }) =>
    (
      <div className={classNames(Classes.productCarouselArrows, cssClasses)} data-dtm={tag}
           data-dtm-attributes={exhibitorId ? JSON.stringify({exhibitorId: exhibitorId}) : null} >
        <i
          aria-hidden="true"
          className={classNames('fa', `fa-${icon}`, className)}
          onClick={() => {
            if (onClick) onClick();
            if (fireMixpanelEvent) fireMixpanelEvent()
          }}
        />
        <span
          className={className}
          onClick={() => {
            if (onClick) onClick();
            if (fireMixpanelEvent) fireMixpanelEvent()
          }}
          role="button"
          tabIndex={0}
        >
          {text}
        </span>
      </div>);
const Prev = arrow('chevron-circle-left', '');
const Next = arrow('chevron-circle-right', Classes.nextArrowRighPosition);

export { Prev, Next };
